import { AiDrawer, AliOssImage } from '@aigc/components';
import { useOverlayRef } from '@aigc/overlay-hook';
import { useNavigate } from '@tanstack/react-router';
import { Button, Empty, Image, Typography } from 'antd';
import type { ImageGenerationTaskDto } from '../../task/model';
import { DEFAULT_IMAGE_MODEL_CODE } from '../image-llm';
import type { GenerateImageInputDto } from '../model';
import { useSetImageGenerationPageData } from '../store';

export const ImageDetailDrawer = (props: { task: ImageGenerationTaskDto }) => {
  const overlayRef = useOverlayRef();
  const navigate = useNavigate();
  const setPageData = useSetImageGenerationPageData();
  // 历史记录的原始参数可能不完整。
  const data: Partial<GenerateImageInputDto> | undefined =
    props.task.generate_data;

  const handleRegenerate = async () => {
    if (!data) return;
    setPageData({
      name: data.name ?? '',
      images: data.images ?? [],
      prompt: data.prompt ?? '',
      aspect_ratio: data.aspect_ratio ?? '9:16',
      model: DEFAULT_IMAGE_MODEL_CODE,
      quantity: 1,
    });
    await overlayRef.close();
    await navigate({ to: '/images' });
  };

  return (
    <AiDrawer
      title="图片详情"
      size={640}
      onClose={() => overlayRef.close()}
      footer={
        <div className="flex items-center justify-end gap-3">
          {!data && (
            <span className="text-primary-400">
              缺少原始生成参数，无法重新生成
            </span>
          )}
          <Button type="primary" disabled={!data} onClick={handleRegenerate}>
            重新生成
          </Button>
        </div>
      }
    >
      <div className="space-y-6">
        <section>
          <Typography.Title level={5}>参考图</Typography.Title>
          {data?.images?.length ? (
            <Image.PreviewGroup>
              <div className="flex flex-wrap gap-3">
                {data.images.map((image, index) => (
                  <AliOssImage
                    key={`(${index})${image.name}`}
                    src={image.url}
                    size={120}
                    alt={`原参考图 ${image.name}`}
                  />
                ))}
              </div>
            </Image.PreviewGroup>
          ) : (
            <Empty description="暂无原参考图" />
          )}
        </section>
        <section>
          <Typography.Title level={5}>提示词</Typography.Title>
          {data?.prompt ? (
            <div className="whitespace-pre-wrap break-words rounded-lg border border-primary-200 p-4">
              {data.prompt}
            </div>
          ) : (
            <Empty description="暂无原提示词" />
          )}
        </section>
      </div>
    </AiDrawer>
  );
};
